import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Drawer, IconButton } from "@mui/material";

type BookNowDrawerProps = {
  open: boolean;
  onClose: () => void;
};

const BookNowDrawer: React.FC<BookNowDrawerProps> = ({ open, onClose }) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      ModalProps={{ keepMounted: true }}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: "80%", md: "80%" },
          maxWidth: "1200px",
          borderLeft: "1px solid rgba(0,0,0,0.1)",
        },
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 2,
            py: 1.5,
            borderBottom: "1px solid #e6e6e6",
            backgroundColor: "#fff",
          }}
        >
          <h2 className="elementor-heading-title elementor-size-default">
            Book Your Stay
          </h2>
          <IconButton onClick={onClose} aria-label="Close booking drawer">
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={{ flex: 1, minHeight: 0, backgroundColor: "#fff" }}>
          <iframe
            src="https://ibe.channex.io/hoteldachi"
            title="Hotel Dachi Booking"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
              display: "block",
            }}
            loading="lazy"
          />
        </Box>
      </Box>
    </Drawer>
  );
};

export default BookNowDrawer;
